import HeroImage from "../assets/contact-hero.jpg";
import ContactImage from "../assets/plutos building.jpg";

function Contact() {
  return (
    <>
      {/* ================= CONTACT HERO SECTION ================= */}
      <section className="relative h-[75vh] flex items-center justify-center overflow-visible">

        {/* BACKGROUND IMAGE */}
        <div
          className="absolute inset-0 bg-cover bg-center scale-105"
          style={{
            backgroundImage: `url(${HeroImage})`,
          }}
        ></div>

        {/* DARK OVERLAY */}
        <div className="absolute inset-0 bg-[#071326]/70"></div>

        {/* OPTIONAL GRADIENT */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/40"></div>

        {/* CONTENT */}
        <div className="relative z-10 text-center text-white px-6 max-w-4xl">

          {/* SMALL LABEL */}
          <p className="uppercase tracking-[7px] text-yellow-400 font-semibold mb-5">
            Contact GATI & CO. ADVOCATES
          </p>

          {/* MAIN HEADING */}
          <h1 className="text-5xl md:text-7xl font-dancing-script leading-tight mb-6">
            Let’s Discuss <br />
            Your Legal Matter
          </h1>

          
        </div>

        {/* BOTTOM FADE */}
        <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-white to-transparent"></div>
        {/* ================= FLOATING CONTACT CARD ================= */}
<div className="absolute -bottom-16 left-6 md:left-16 z-20">

  <div className="bg-[#0B3D91] text-white w-[320px] md:w-[420px] p-8 rounded-[28px] shadow-2xl border border-white/10">

    {/* SMALL LABEL */}
    <p className="uppercase tracking-[5px] text-yellow-400 text-sm font-semibold mb-3">
      Reach Out
    </p>

    {/* HEADING */}
    <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-4">
      Contact Us
    </h2>

    {/* TEXT */}
    <p className="text-gray-200 leading-relaxed text-lg">
      We typically respond quickly:
    </p>

  </div>

</div>

      </section>
      {/* ================= LOCATION & JURISDICTION SECTION ================= */}
<section className="py-28 px-6 md:px-16 bg-[#F8F8F8]">

  <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">

    {/* ================= LEFT CONTENT ================= */}
    <div>

      {/* SMALL LABEL */}
      <p className="uppercase tracking-[6px] text-yellow-600 font-semibold mb-4">
        Our Reach
      </p>

      {/* HEADING */}
      <h2 className="text-4xl md:text-5xl font-bold text-[#0B1C39] leading-tight mb-8">
        Physical & Jurisdictional Reach
      </h2>

      {/* OFFICE CARD */}
      <div className="bg-white rounded-[28px] p-8 shadow-lg border border-gray-100 mb-8">

        <h3 className="text-2xl font-bold text-[#0B3D91] mb-4">
          Physical Office
        </h3>

        <p className="text-gray-700 leading-relaxed mb-6">
          <span className="font-semibold">
            Plutos House, 3rd Floor, Suite No. 6
          </span>
          <br />
          A landmark building along the Nakuru CBD.
        </p>

        {/* FEATURES */}
        <div className="space-y-4">

          <div className="flex items-center gap-3">
            <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
            <p className="text-gray-600">
              Secure entry & waiting area
            </p>
          </div>

          <div className="flex items-center gap-3">
            <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
            <p className="text-gray-600">
              Confidential client meeting room
            </p>
          </div>

          <div className="flex items-center gap-3">
            <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
            <p className="text-gray-600">
              Nearby parking
            </p>
          </div>

        </div>

      </div>

      {/* JURISDICTION CARD */}
      <div className="bg-white rounded-[28px] p-8 shadow-lg border border-gray-100">

        <h3 className="text-2xl font-bold text-[#0B3D91] mb-6">
          Jurisdictions We Serve
        </h3>

        {/* TABLE */}
        <div className="space-y-5">

          {/* ITEM */}
          <div className="flex items-center justify-between border-b border-gray-100 pb-4">
            <p className="font-medium text-gray-700">
              Nakuru Law Courts
            </p>

            <span className="text-green-600 font-semibold">
              ✅ Daily
            </span>
          </div>

          <div className="flex items-center justify-between border-b border-gray-100 pb-4">
            <p className="font-medium text-gray-700">
              Nakuru Chief Magistrate’s Court
            </p>

            <span className="text-green-600 font-semibold">
              ✅ Daily
            </span>
          </div>

          <div className="flex items-center justify-between border-b border-gray-100 pb-4">
            <p className="font-medium text-gray-700">
              Nakuru Lands Registry
            </p>

            <span className="text-green-600 font-semibold">
              ✅ Weekly
            </span>
          </div>

          <div className="flex items-center justify-between border-b border-gray-100 pb-4">
            <p className="font-medium text-gray-700">
              Nakuru Land Control Board
            </p>

            <span className="text-green-600 font-semibold">
              ✅ As Needed
            </span>
          </div>

          <div className="flex items-center justify-between border-b border-gray-100 pb-4">
            <p className="font-medium text-gray-700">
              Environment & Land Court (Nakuru)
            </p>

            <span className="text-green-600 font-semibold">
              ✅
            </span>
          </div>

          <div className="flex items-center justify-between border-b border-gray-100 pb-4">
            <p className="font-medium text-gray-700">
              Court of Appeal (Nairobi)
            </p>

            <span className="text-[#0B3D91] font-semibold text-right">
              Via Referral Partnership
            </span>
          </div>

          <div className="flex items-center justify-between">
            <p className="font-medium text-gray-700">
              Supreme Court
            </p>

            <span className="text-[#0B3D91] font-semibold text-right">
              Via Referral Partnership
            </span>
          </div>

        </div>

        {/* FOOTNOTE */}
        <p className="mt-8 text-gray-600 leading-relaxed">
          We also handle matters originating in
          <span className="font-semibold text-[#0B1C39]">
            {" "}Molo, Njoro, Gilgil, Naivasha, Kericho,
          </span>
          {" "}and
          <span className="font-semibold text-[#0B1C39]">
            {" "}Eldoret
          </span>
          {" "}on instruction.
        </p>

      </div>

    </div>

    {/* ================= RIGHT SIDE MAP ================= */}
    <div className="relative">

      {/* MAP CONTAINER */}
      <div className="rounded-[32px] overflow-hidden shadow-2xl border border-gray-200 h-[750px]">

        <iframe
  title="GATI & CO Location"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5364.294719426859!2d36.06562373107361!3d-0.2848945959403228!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x18298d95ec2ccc97%3A0x2373b87b1c8d60c4!2sPlutos%20Building%2C%20Kenyatta%20Ave%2C%20Nakuru!5e0!3m2!1sen!2ske!4v1779978408023!5m2!1sen!2ske"
  width="100%"
  height="100%"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
  className="w-full h-full"
></iframe>

      </div>

      {/* FLOATING INFO CARD */}
      <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-md rounded-2xl p-6 shadow-xl max-w-xs">

        <p className="uppercase tracking-[4px] text-yellow-600 text-xs font-semibold mb-2">
          Main Office
        </p>

        <h4 className="text-xl font-bold text-[#0B1C39] mb-2">
          GATI & CO. ADVOCATES
        </h4>

        <p className="text-gray-600 leading-relaxed text-sm">
          Plutos House, 3rd Floor,
          Suite No. 6, Nakuru CBD.
        </p>

      </div>

    </div>

  </div>

</section>
{/* ================= CONNECT WITH COUNSEL ================= */}
<section className="py-28 px-6 md:px-16 bg-white overflow-hidden">

  <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">

    {/* ================= LEFT IMAGE ================= */}
    <div className="relative group">

      {/* MAIN IMAGE */}
      <div className="overflow-hidden rounded-[32px] shadow-2xl">
        <img
          src={ContactImage}
          alt="GATI & CO. ADVOCATES"
          className="w-full h-[650px] object-cover group-hover:scale-105 transition duration-700"
        />
      </div>

      {/* FLOATING CARD */}
      <div className="absolute bottom-8 left-8 bg-white/95 backdrop-blur-md p-6 rounded-2xl shadow-xl max-w-xs border border-gray-100">

        <p className="uppercase tracking-[4px] text-yellow-600 text-xs font-semibold mb-2">
          Available & Responsive
        </p>

        <h3 className="text-2xl font-bold text-[#0B1C39] mb-3">
          Connect With Counsel
        </h3>

        <p className="text-gray-600 leading-relaxed text-sm">
          We are ready when you are — with clarity, speed,
          and professional legal guidance.
        </p>

      </div>

    </div>

    {/* ================= RIGHT CONTENT ================= */}
    <div>

      {/* SMALL LABEL */}
      <p className="uppercase tracking-[6px] text-yellow-600 font-semibold mb-4">
        Contact Information
      </p>

      {/* HEADING */}
      <h2 className="text-4xl md:text-5xl font-bold text-[#0B1C39] leading-tight mb-8">
        Reach GATI & CO. <br />
        ADVOCATES
      </h2>

      {/* INTRO */}
      <p className="text-gray-600 text-lg leading-relaxed mb-10">
        We are ready when you are. Reach out for legal guidance,
        urgent representation, consultations, or document review.
      </p>

      {/* CONTACT CARDS */}
      <div className="space-y-6">

        {/* POSTAL */}
        <div className="bg-[#F8F8F8] rounded-[24px] p-7 border border-gray-100 hover:shadow-lg transition duration-300">

          <p className="text-yellow-600 font-semibold uppercase tracking-[4px] text-sm mb-3">
            Postal Address
          </p>

          <h3 className="text-2xl font-bold text-[#0B3D91] mb-2">
            P.O. BOX 881-20100
          </h3>

          <p className="text-gray-600 leading-relaxed">
            Nakuru, Kenya
          </p>

        </div>

        {/* PHONE */}
        <div className="bg-[#F8F8F8] rounded-[24px] p-7 border border-gray-100 hover:shadow-lg transition duration-300">

          <p className="text-yellow-600 font-semibold uppercase tracking-[4px] text-sm mb-3">
            Telephone / WhatsApp
          </p>

          <h3 className="text-2xl font-bold text-[#0B3D91] leading-relaxed mb-3">
            0710565929 <br />
            0710304880 <br />
            0729870060
          </h3>

          <p className="text-gray-600 leading-relaxed">
            Voice calls preferred between 9 AM – 5 PM weekdays.
            WhatsApp available for secure document exchange.
          </p>

        </div>

        {/* EMAIL */}
        <div className="bg-[#F8F8F8] rounded-[24px] p-7 border border-gray-100 hover:shadow-lg transition duration-300">

          <p className="text-yellow-600 font-semibold uppercase tracking-[4px] text-sm mb-3">
            Email Address
          </p>

          <h3 className="text-2xl font-bold text-[#0B3D91] mb-3 break-all">
            gaticoadvocates@gmail.com
          </h3>

          <p className="text-gray-600 leading-relaxed">
            Email is monitored 7 days a week.
            Expect acknowledgment within 4 hours.
          </p>

        </div>

        {/* OFFICE */}
        <div className="bg-[#0B1C39] rounded-[24px] p-7 text-white shadow-2xl">

          <p className="text-yellow-400 font-semibold uppercase tracking-[4px] text-sm mb-3">
            Physical Visit
          </p>

          <h3 className="text-2xl font-bold mb-4">
            Plutos House, 3rd Floor, Suite No. 6
          </h3>

          <p className="text-gray-300 leading-relaxed">
            Opposite Nyayo Gardens, Nakuru CBD.
            Easily accessible with nearby parking
            and a confidential client meeting environment.
          </p>

        </div>

      </div>

    </div>

  </div>

</section>
    </>
  );
}

export default Contact;